import { Component, inject } from '@angular/core';
import { MessageService } from "../../services/helpers/message.service";
import { NgClass, NgIf } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-message',
  imports: [
    NgIf,
    TranslateModule
  ],
  template: `
    <div
      *ngIf="message()"
      class="fixed top-24 left-1/2 -translate-x-1/2 z-[1100] cursor-pointer"
      [@fadeInOut]
      (@fadeInOut.done)="animationDone($event)"
      (click)="onClose()"
    >
      <div
        class="bg-[#121212] rounded-3xl p-6 flex flex-row gap-5 items-start shadow-[0_0_56px_rgba(0,0,0,0.2)]"
      >
        <!-- Иконка -->
        <div class="shrink-0 w-14 h-14 flex items-center justify-center">
          <img
            *ngIf="message()?.severity === 'success'" src="/images/icons/success.svg" alt=""
            class="w-8 h-8"
          />
          <img
            *ngIf="message()?.severity === 'error'" src="/images/icons/error.svg" alt=""
            class="w-8 h-8"
          />
          <img
            *ngIf="message()?.severity === 'warning'" src="/images/icons/warning.svg" alt=""
            class="w-12 h-12"
          />
          <img
            *ngIf="message()?.severity === 'info'" src="/images/icons/info.svg" alt=""
            class="w-8 h-8"
          />
        </div>

        <!-- Текст -->
        <div class="flex flex-col gap-1">
          <p class="text-white font-semibold text-lg">
            {{ message()!.severity | translate }}
          </p>
          <p class="text-[rgba(255,255,255,0.8)] text-sm">
            {{ message()!.text | translate }}
          </p>
        </div>
      </div>
    </div>
  `,
  animations: [
  trigger('fadeInOut', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate('200ms ease-out', style({ opacity: 1 })),
    ]),
    transition(':leave', [
      animate('200ms ease-in', style({ opacity: 0 })),
    ]),
  ]),
],
})
export class MessageComponent {
  #messageService = inject(MessageService);

  message = this.#messageService.message;

  onClose(): void {
    this.#messageService.clear();
  }

  animationDone(event: any) {
    // Если нужно что-то делать после анимации
  }
}
